import axios from "axios"

import { isValidToken } from "@sap/utils/jwt"

import { useAuthStore } from "@/store/auth"

import { BACKEND_URL } from "../config"
import i18n from "../locales/i18n"

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: BACKEND_URL,
  paramsSerializer: {
    indexes: null,
  },
})

export const axiosUnauthenticated = axios.create({
  baseURL: BACKEND_URL,
})

axiosInstance.interceptors.request.use(
  async function (config) {
    let accessToken = useAuthStore.getState().accessToken
    if (isValidToken(accessToken)) {
      config.headers.Authorization = `Bearer ${accessToken}`
    } else {
      await useAuthStore.getState().refreshAccessToken()
      accessToken = useAuthStore.getState().accessToken
      config.headers.Authorization = `Bearer ${accessToken}`
    }

    config.headers["Accept-Language"] = i18n.language
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default axiosInstance
